import { render } from "./ProductsManagement.vue?vue&type=template&id=f885a630&scoped=true"
import script from "./ProductsManagement.vue?vue&type=script&lang=js"
export * from "./ProductsManagement.vue?vue&type=script&lang=js"

import "./ProductsManagement.vue?vue&type=style&index=0&id=f885a630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f885a630"]])

export default __exports__